import axios from "axios";
import { store } from "../../store";

export async function createOpeningHoursConstantAction() {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");
  const { opened, openedFrom, openedTo, type } =
    store.getState().openingHoursConstant;

  const modifiedOpenedFrom = `${new Date(openedFrom)
    .getHours()
    .toString()
    .padStart(2, "0")}:${new Date(openedFrom)
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;

  const modifiedOpenedTo = `${new Date(openedTo)
    .getHours()
    .toString()
    .padStart(2, "0")}:${new Date(openedTo)
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;

  const params = {
    opened,
    openedTo: modifiedOpenedTo,
    openedFrom: modifiedOpenedFrom,
    type: type === null ? 1 : type,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/opening-hours-constant`,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
